import { toneVariant, useCompanionNoun } from '@/utils/personalization'
import { addAgeToLocalStorage } from '@app-studio-web/ui/helpers/localStorage'
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import type { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🌱',
    title: 'pages.onboarding.ageQuestion.18_24',
    value: '18_24',
  },
  {
    emoji: '🌿',
    title: 'pages.onboarding.ageQuestion.25_34',
    value: '25_34',
  },
  {
    emoji: '🌳',
    title: 'pages.onboarding.ageQuestion.35_44',
    value: '35_44',
  },
  {
    emoji: '🌻',
    title: 'pages.onboarding.ageQuestion.45_54',
    value: '45_54',
  },
  {
    emoji: '🌟',
    title: 'pages.onboarding.ageQuestion.55_64',
    value: '55_64',
  },
  {
    emoji: '✨',
    title: 'pages.onboarding.ageQuestion.65_plus',
    value: '65_plus',
  },
  {
    emoji: '💫',
    title: 'pages.onboarding.ageQuestion.prefer_not_to_say',
    value: 'other',
  },
]

export default function AgeQuestionPage() {
  const noun = useCompanionNoun()
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const selected = (event.target as HTMLInputElement).value
    if (selected) addAgeToLocalStorage(selected)
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      onSubmit={handleSubmit}
      subtitle={toneVariant('pages.onboarding.ageQuestion.subtitle')}
      title="pages.onboarding.ageQuestion.title"
      translationInterpolation={{ noun }}
    />
  )
}
